import gql from "graphql-tag";

export const GET_SCHEDULED_PAYMENTS = gql`
    query GetScheduledPayments($options: ArrayDataOptions) {
        scheduledPayments(options: $options) {
            existsMore
            total
            items {
                id
                paymentDue
                paymentAmount
                refundedAmount
                providerRefundedAmount
                molliePaidAmount
                surplusMolliePaymentCount
                openAmount
                createDate
                paymentDone
                note
                invoice {
                    billed
                    invoiceNumber
                    invoiceNumberPrefix
                    createDate
                    updateDate
                    id
                }
                booking {
                    id
                    courseId
                    bookingNumberPrefix
                    bookingNumber
                    bookingType
                    isSpecial
                    vat
                    netPrice
                    grossPrice
                    bookedBy
                    paymentType
                    invoice {
                        id
                    }
                    paymentMethod {
                        id
                        cash
                        esr
                        creditCardAccountholder
                        creditcardNumber
                        expirationDate
                        validFrom
                        cvc
                        paypalAccountholder
                        email
                        iban
                        bank
                        bic
                        sepaAccountholder
                        type
                        bankTransfer
                        onlinePayment
                    }
                    attendee {
                        id
                        erasedAt
                        firstname
                        lastname
                        booker {
                            id
                            firstname
                            lastname
                            email
                            nonDisclosureNotice
                        }
                    }
                    courseLessons {
                        id
                        startDateTime
                        endDateTime
                        course {
                            id
                            startDateTime
                            paymentInterval
                            prefixedCourseNumber
                            courseType {
                                id
                                name
                                color
                            }
                        }
                        location {
                            id
                            city
                            name
                        }
                    }
                    canceled
                    bookingType
                    noticeStaff
                }
                paymentTransferType
                paymentMethodId
                paymentMethod {
                    id
                    cash
                    esr
                    creditCardAccountholder
                    creditcardNumber
                    expirationDate
                    validFrom
                    cvc
                    paypalAccountholder
                    email
                    iban
                    bank
                    bic
                    sepaAccountholder
                    type
                    bankTransfer
                    onlinePayment
                }
                title
                type
                note
                paymentProvider
                mollieMethod
                molliePaymentStatus
                molliePaymentUrl
                mollieErrorMessage
                mollieRetryCount
                methodChangedAt
                methodChangedBy {
                    id
                    email
                }
            }
        }
    }
`;

export const GET_UNPAID_PAYMENTS = gql`
    query getUnpaidScheduledPayments($options: ArrayDataOptions, $bookingId: ID, $includeDeleted: Boolean, $respectArchiveSetting: Boolean, $dunningDue: Boolean) {
        unpaidScheduledPayments(options: $options, bookingId: $bookingId, includeDeleted: $includeDeleted, respectArchiveSetting: $respectArchiveSetting, dunningDue: $dunningDue) {
            existsMore
            total
            items {
                id
                dunningStatus {
                    bookingId
                    level
                    levelDate
                    nextLevel
                    nextDate
                    due
                    pausedUntil
                }
                paymentDue
                paymentAmount
                refundedAmount
                providerRefundedAmount
                molliePaidAmount
                openAmount
                createDate
                paymentDone
                invoice {
                    id
                    createDate
                    updateDate
                    invoiceNumber
                    invoiceNumberPrefix
                }
                booking {
                    id
                    courseId
                    bookingNumberPrefix
                    bookingNumber
                    bookingType
                    isSpecial
                    vat
                    netPrice
                    grossPrice
                    bookedBy
                    paymentType
                    invoice {
                        id
                    }
                    paymentMethod {
                        id
                        cash
                        esr
                        creditCardAccountholder
                        creditcardNumber
                        expirationDate
                        validFrom
                        cvc
                        paypalAccountholder
                        email
                        iban
                        bank
                        bic
                        sepaAccountholder
                        type
                        bankTransfer
                        onlinePayment
                    }
                    attendee {
                        id
                        erasedAt
                        firstname
                        lastname
                        booker {
                            id
                            firstname
                            lastname
                            email
                            nonDisclosureNotice
                        }
                    }
                    courseLessons {
                        id
                        startDateTime
                        endDateTime
                        course {
                            id
                            startDateTime
                            paymentInterval
                            prefixedCourseNumber
                            courseType {
                                id
                                name
                                color
                            }
                        }
                        location {
                            id
                            city
                            name
                        }
                    }
                    canceled
                    bookingType
                    noticeStaff
                }
                sepaClearance
                paymentTransferType
                paymentMethodId
                paymentMethod {
                    id
                    cash
                    esr
                    creditCardAccountholder
                    creditcardNumber
                    expirationDate
                    validFrom
                    cvc
                    paypalAccountholder
                    email
                    iban
                    bank
                    bic
                    sepaAccountholder
                    type
                    bankTransfer
                    onlinePayment
                }
                title
                type
                note
                paymentProvider
                mollieMethod
                molliePaymentStatus
                molliePaymentUrl
                mollieErrorMessage
                mollieRetryCount
                methodChangedAt
                methodChangedBy {
                    id
                    email
                }
                manuallyAdjustedAt
                manuallyAdjustedByUserId
                manuallyAddedAt
                transferFromBookingNumber
                transferPaidAmount
                manuallyAdjustedBy {
                    id
                    email
                }
                deletedAt
                deletedByUserId
                deletedBy {
                    id
                    email
                }
            }
        }
    }
`;

// unpaidScheduledPaymentsZeroValues
export const GET_UNPAID_PAYMENTS_ZERO_VALUES = gql`
    query GetUnpaidScheduledPaymentsZeroValues($options: ArrayDataOptions) {
        unpaidScheduledPaymentsZeroValues(options: $options) {
            id
            paymentDue
            paymentAmount
            refundedAmount
            providerRefundedAmount
            molliePaidAmount
            openAmount
            createDate
            paymentDone
            invoice {
                id
                createDate
                updateDate
                invoiceNumber
                invoiceNumberPrefix
            }
            booking {
                id
                courseId
                bookingNumberPrefix
                bookingNumber
                bookingType
                isSpecial
                vat
                netPrice
                grossPrice
                bookedBy
                paymentType
                invoice {
                    id
                }
                paymentMethod {
                    id
                    cash
                    esr
                    creditCardAccountholder
                    creditcardNumber
                    expirationDate
                    validFrom
                    cvc
                    paypalAccountholder
                    email
                    iban
                    bank
                    bic
                    sepaAccountholder
                    type
                    bankTransfer
                    onlinePayment
                }
                attendee {
                    id
                    erasedAt
                    firstname
                    lastname
                    booker {
                        id
                        firstname
                        lastname
                        email
                        nonDisclosureNotice
                    }
                }
                courseLessons {
                    id
                    startDateTime
                    endDateTime
                    course {
                        id
                        startDateTime
                        paymentInterval
                        prefixedCourseNumber
                        courseType {
                            id
                            name
                            color
                        }
                    }
                    location {
                        id
                        city
                        name
                    }
                }
                canceled
                bookingType
                noticeStaff
            }
            sepaClearance
            paymentTransferType
            paymentMethodId
            paymentMethod {
                id
                cash
                esr
                creditCardAccountholder
                creditcardNumber
                expirationDate
                validFrom
                cvc
                paypalAccountholder
                email
                iban
                bank
                bic
                sepaAccountholder
                type
                bankTransfer
                onlinePayment
            }
            title
            type
            note
            paymentProvider
            mollieMethod
            molliePaymentStatus
            molliePaymentUrl
            mollieErrorMessage
            mollieRetryCount
            methodChangedAt
            methodChangedBy {
                id
                email
            }
        }
    }
`;

// #1141: Doppelzahlung(en) einer Rate als erledigt markieren (blendet das Badge aus).
export const RESOLVE_SURPLUS_MOLLIE_PAYMENTS = gql`
    mutation ResolveSurplusMolliePayments($scheduledPaymentId: ID!) {
        resolveSurplusMolliePayments(scheduledPaymentId: $scheduledPaymentId)
    }
`;

export const GET_PAID_PAYMENTS = gql`
    query getPaidScheduledPayments($options: ArrayDataOptions, $bookingId: ID, $includeDeleted: Boolean, $respectArchiveSetting: Boolean) {
        paidScheduledPayments(options: $options, bookingId: $bookingId, includeDeleted: $includeDeleted, respectArchiveSetting: $respectArchiveSetting) {
            existsMore
            total
            items {
                id
                paymentDue
                paymentAmount
                refundedAmount
                providerRefundedAmount
                molliePaidAmount
                surplusMolliePaymentCount
                openAmount
                createDate
                paymentDone
                note
                invoice {
                    id
                    createDate
                    updateDate
                    invoiceNumber
                    invoiceNumberPrefix
                }
                booking {
                    id
                    courseId
                    bookingNumberPrefix
                    bookingNumber
                    bookingType
                    isSpecial
                    vat
                    netPrice
                    grossPrice
                    bookedBy
                    paymentType
                    invoice {
                        id
                    }
                    paymentMethod {
                        id
                        cash
                        esr
                        creditCardAccountholder
                        creditcardNumber
                        expirationDate
                        validFrom
                        cvc
                        paypalAccountholder
                        email
                        iban
                        bank
                        bic
                        sepaAccountholder
                        type
                        bankTransfer
                        onlinePayment
                    }
                    attendee {
                        id
                        erasedAt
                        firstname
                        lastname
                        booker {
                            id
                            firstname
                            lastname
                            email
                            nonDisclosureNotice
                        }
                    }
                    courseLessons {
                        id
                        startDateTime
                        endDateTime
                        course {
                            id
                            startDateTime
                            paymentInterval
                            prefixedCourseNumber
                            courseType {
                                id
                                name
                                color
                            }
                        }
                        location {
                            id
                            city
                            name
                        }
                    }
                    canceled
                    bookingType
                    noticeStaff
                }
                sepaClearance
                paymentTransferType
                paymentMethodId
                paymentMethod {
                    id
                    cash
                    esr
                    creditCardAccountholder
                    creditcardNumber
                    expirationDate
                    validFrom
                    cvc
                    paypalAccountholder
                    email
                    iban
                    bank
                    bic
                    sepaAccountholder
                    type
                    bankTransfer
                    onlinePayment
                }
                title
                type
                note
                paymentProvider
                mollieMethod
                molliePaymentStatus
                molliePaymentUrl
                mollieErrorMessage
                mollieRetryCount
                methodChangedAt
                methodChangedBy {
                    id
                    email
                }
                manuallyAdjustedAt
                manuallyAdjustedByUserId
                manuallyAddedAt
                transferFromBookingNumber
                transferPaidAmount
                manuallyAdjustedBy {
                    id
                    email
                }
                deletedAt
                deletedByUserId
                deletedBy {
                    id
                    email
                }
            }
        }
    }
`;

export const GET_SCHEDULED_PAYMENTS_SUMMARY = gql`
    query GetScheduledPaymentsSummary($paymentDone: Boolean!, $options: ArrayDataOptions, $respectArchiveSetting: Boolean) {
        scheduledPaymentSummary(paymentDone: $paymentDone, options: $options, respectArchiveSetting: $respectArchiveSetting) {
            filtered {
                count
                sum
            }
            total {
                count
                sum
            }
        }
    }
`;

export const GET_SCHEDULED_PAYMENTS_MIN = gql`
    query GetScheduledPaymentsMin($options: ArrayDataOptions) {
        scheduledPayments(options: $options) {
            existsMore
            total
            items {
                id
                paymentDue
                paymentAmount
                openAmount
                paymentTransferType
                title
            }
        }
    }
`;

export const GET_SCHEDULED_PAYMENT_BY_ID = gql`
    query getScheduledPaymentById($id: ID!) {
        scheduledPaymentById(id: $id) {
            id
        }
    }
`;

export const DELETE_SCHEDULED_PAYMENT = gql`
    mutation DeleteScheduledPayment($id: String!) {
        deleteScheduledPayment(id: $id) {
            id
        }
    }
`;

export const UPDATE_SCHEDULED_PAYMENT_BY_ID = gql`
    mutation UpdateScheduledPayment($editScheduledPaymentData: EditScheduledPaymentInput!, $id: String!) {
        updateScheduledPayment(editScheduledPaymentData: $editScheduledPaymentData, id: $id) {
            id
            paymentDone
        }
    }
`;

export const UPDATE_SCHEDULED_PAYMENT_BY_IDS = gql`
    mutation UpdateManyScheduledPaymentIds($paymentIds: [ID!]!, $editScheduledPaymentData: EditScheduledPaymentInput!) {
        updateManyScheduledPaymentIds(paymentIds: $paymentIds, editScheduledPaymentData: $editScheduledPaymentData) {
            id
            paymentDone
        }
    }
`;

// // setMultipleScheduledPaymentsPaid
// export const SET_MULTIPLE_SCHEDULED_PAYMENTS_PAID = gql`
//     mutation SetMultipleScheduledPaymentsPaid(
//         $paymentIds: [ID!]!
//         $paymentDone: DateTime!
//     ) {
//         setMultipleScheduledPaymentsPaid(
//             paymentIds: $paymentIds
//             paymentDone: $paymentDone
//         ) {
//             id
//             paymentDone
//         }
//     }
// `;

// setMultipleScheduledPaymentsPaid
export const SET_MULTIPLE_SCHEDULED_PAYMENTS_PAID = gql`
    mutation SetMultipleScheduledPaymentsPaid($paymentIds: [ID!]!, $paymentDone: DateTime!) {
        setMultipleScheduledPaymentsPaid(paymentIds: $paymentIds, paymentDone: $paymentDone)
    }
`;

export const SET_SEPA_CLEARANCE = gql`
    mutation setSepaClearance($id: ID!, $sepaClearance: Boolean!) {
        setSepaClearance(id: $id, sepaClearance: $sepaClearance) {
            id
            sepaClearance
        }
    }
`;

export const GET_SCHEDULED_PAYMENTS_BY_BOOKING_ID = gql`
    query GetScheduledPaymentsByBookingId($bookingId: ID!) {
        scheduledPaymentsByBookingId(bookingId: $bookingId) {
            id
            paymentDue
            paymentAmount
            openAmount
            createDate
            paymentDone
            paymentTransferType
            invoice {
                id
                createDate
                invoiceNumber
                invoiceNumberPrefix
            }
            title
        }
    }
`;

export const GENERATE_PAYMENTSCHEDULE_PREVIEW = gql`
    mutation GeneratePaymentSchedulePreview($lessonDates: [DateTime!]!, $bookingPrice: Float!, $monthlySchedule: MonthlySchedule!, $paymentType: PaymentType!, $courseId: ID) {
        generatePaymentSchedulePreview(lessonDates: $lessonDates, bookingPrice: $bookingPrice, monthlySchedule: $monthlySchedule, paymentType: $paymentType, courseId: $courseId)
    }
`;

export const GENERATE_UPDATED_SCHEDULES_NEW_BOOKINGPRICE = gql`
    mutation GenerateUpdatedSchedulesNewBookingPrice($scheduledPayments: [UpdateScheduledPaymentByBookingInput!]!, $bookingPrice: Float!) {
        generateUpdatedSchedulesNewBookingPrice(scheduledPayments: $scheduledPayments, bookingPrice: $bookingPrice) {
            id
            paymentAmount
            openAmount
            paymentDue
        }
    }
`;

export const RESET_SCHEDULED_PAYMENTS_OF_BOOKING = gql`
    mutation ResetScheduledPaymentsOfBooking($bookingId: ID!, $preview: Boolean) {
        resetScheduledPaymentsOfBooking(bookingId: $bookingId, preview: $preview) {
            bookingId
            bookingNumber
            bookingPrice
            coursePrice
            creditedBalance
            currentScheduledPaymentsCount
            newScheduledPaymentsCount
            currentScheduledPaymnetsCount
            installmentPlanAmountsAndDueDates {
                key
                value {
                    due
                    amount
                }
            }
            newScheduledPaymentsAmountsAndDueDates {
                key
                value {
                    due
                    amount
                }
            }
            currentScheduledPaymentsAmountsAndDueDates {
                key
                value {
                    due
                    amount
                }
            }
        }
    }
`;

export const RESET_ALL_UNSETTELED_SCHEDULED_PAYMENTS_OF_COURSE = gql`
    mutation ResetAllUnsetteledScheduledPaymentsOfCourse($courseId: ID!, $preview: Boolean) {
        resetAllUnsetteledScheduledPaymentsOfCourse(courseId: $courseId, preview: $preview) {
            courseId
            coursePrice
            courseDueDates {
                key
                value {
                    due
                    amount
                }
            }
            bookings {
                bookingId
                bookingNumber
                bookingPrice
                creditedBalance
                currentScheduledPaymentsCount
                newScheduledPaymentsCount
                currentScheduledPaymnetsCount
                #installmentPlanAmountsAndDueDates {
                #  key
                #  value {
                #    due
                #    amount
                #  }
                #}
                newScheduledPaymentsAmountsAndDueDates {
                    key
                    value {
                        due
                        amount
                    }
                }
                currentScheduledPaymentsAmountsAndDueDates {
                    key
                    value {
                        due
                        amount
                    }
                }
            }
        }
    }
`;

export const SCHEDULED_PAYMENTS_BY_BOOKER_ID = gql`
    query ScheduledPaymentsByBookerId($bookerId: ID!) {
        scheduledPaymentsByBookerId(bookerId: $bookerId) {
            id
            paymentDue
            paymentAmount
            openAmount
            paymentDone
            createDate
            sepaClearance
            paymentMethodId
        }
    }
`;

export const SET_SCHEDULED_PAYMENT_PAID = gql`
    mutation SetScheduledPaymentPaid($id: String!, $paymentDone: DateTime!) {
        setScheduledPaymentPaid(id: $id, paymentDone: $paymentDone) {
            id
            paymentDone
        }
    }
`;

export const SET_SCHEDULED_PAYMENT_UNPAID = gql`
    mutation SetScheduledPaymentUnpaid($id: String!) {
        setScheduledPaymentUnpaid(id: $id) {
            id
            paymentDone
        }
    }
`;

export const SET_NEW_PAYMENT_DONE_DATE = gql`
    mutation SetNewPaymentDoneDate($id: String!, $paymentDoneDate: DateTime!) {
        setNewPaymentDoneDate(id: $id, paymentDoneDate: $paymentDoneDate) {
            id
            paymentDone
        }
    }
`;

export const SET_NEW_PAYMENT_AMOUNT = gql`
    mutation SetNewPaymentAmount($id: String!, $paymentAmount: Float!) {
        setNewPaymentAmount(id: $id, paymentAmount: $paymentAmount) {
            id
            paymentAmount
            openAmount
        }
    }
`;

export const MODIFY_SCHEDULED_PAYMENT = gql`
    mutation ModifyScheduledPayment($modifyScheduledPaymentInput: ModifyScheduledPaymentInput!) {
        modifyScheduledPayment(modifyScheduledPaymentInput: $modifyScheduledPaymentInput) {
            id
            paymentAmount
            openAmount
            paymentDue
            paymentDone
            paymentMethodId
            sepaClearance
            title
            type
        }
    }
`;

export const GENERATE_SCHEDULED_PAYMENTS_FOR_SETTLED_BOOKING = gql`
    mutation GenerateScheduledPaymentsForSettledBooking($bookingId: ID!, $savePayments: Boolean) {
        generateScheduledPaymentsForSettledBooking(bookingId: $bookingId, savePayments: $savePayments) {
            id
            paymentAmount
            openAmount
            paymentDue
            paymentDone
            paymentMethodId
            sepaClearance
        }
    }
`;

export const ADD_NAMED_SCHEDULED_PAYMENT = gql`
    mutation AddNamedScheduledPayment($addNamedScheduledPaymentInput: AddNamedScheduledPaymentInput!) {
        addNamedScheduledPayment(addNamedScheduledPaymentInput: $addNamedScheduledPaymentInput) {
            id
            paymentAmount
            openAmount
            paymentDue
            paymentDone
            paymentMethodId
            sepaClearance
        }
    }
`;

export const UPDATE_SETTLED_BOOKING_DISCOUNT = gql`
    mutation UpdateSettledBookingDiscount(
        $bookingId: ID!
        $discount: Float
        $discountName: String
        $memberDiscount: Float
        $creditedBalance: Float
    ) {
        updateSettledBookingDiscount(
            bookingId: $bookingId
            discount: $discount
            discountName: $discountName
            memberDiscount: $memberDiscount
            creditedBalance: $creditedBalance
        ) {
            id
            discount
            discountName
            memberDiscount
            creditedBalance
            grossPrice
            netPrice
            scheduledPayments {
                id
                paymentAmount
                openAmount
                paymentDone
                type
            }
        }
    }
`;

export const GENERATE_SCHEDULED_PAYMENTS_BY_COURSE = gql`
    mutation GenerateScheduledPaymentsByCourse(
        $courseId: ID!
        $attendeeId: ID
        $omitMemberDiscount: Boolean
        $creditedBalance: Float
        $currentScheduledPayments: [ScheduledPaymentSimpleInput!]
        $paymentType: PaymentType
        $memberDiscount: Float
        $discount: Float
        $additionalItemIds: [ID!]
        $discountCode: String
    ) {
        generateScheduledPaymentsByCourse(
            courseId: $courseId
            attendeeId: $attendeeId
            omitMemberDiscount: $omitMemberDiscount
            creditedBalance: $creditedBalance
            currentScheduledPayments: $currentScheduledPayments
            paymentType: $paymentType
            memberDiscount: $memberDiscount
            discount: $discount
            additionalItemIds: $additionalItemIds
            discountCode: $discountCode
        ) {
            scheduledPayments {
                id
                paymentAmount
                paymentDue
                type
                title
                additionalItemId
                vat
            }
            grossPrice
            netPrice
            memberDiscount
            discountCode
            discount
            discountName
        }
    }
`;

export const GET_SCHEDULED_PAYMENTS_WITH_MISSING_INVOICE_IDS = gql`
    query GetScheduledPaymentsWithMissingInvoiceIds {
        scheduledPaymentsWithMissingInvoiceIds {
            id
            bookingId
            paymentAmount
            paymentDue
            invoiceId
            booking {
                id
                bookingNumber
                bookingNumberPrefix
                courseLessons {
                    course {
                        prefixedCourseNumber
                    }
                }
            }
        }
    }
`;

export const FIX_MISSING_INVOICE_IDS = gql`
    mutation FixMissingInvoiceIds($scheduledPaymentIds: [ID!]) {
        fixMissingInvoiceIds(scheduledPaymentIds: $scheduledPaymentIds)
    }
`;

// B-223 Wave 7 — Override-Aufhebung fuer einen einzelnen ScheduledPayment.
// Setzt manuallyAdjustedAt + manuallyAdjustedByUserId auf null, sodass der
// naechste Recalc den Posten wieder normal behandelt (bzw. ihn loescht, falls
// es ein manuell hinzugefuegter Posten mit title!=null ist — Frontend warnt
// im Popconfirm entsprechend).
//
// Server-Resolver: scheduledPayment.resolver.ts:222-234.
// Server-Service:  scheduledPayment.service.ts:1863+ (Tombstone-Guard +
//                  Apollo-Error wenn keine Anpassung vorhanden).
export const CLEAR_MANUALLY_ADJUSTED = gql`
    mutation ClearManuallyAdjusted($id: String!) {
        clearManuallyAdjusted(id: $id) {
            id
            manuallyAdjustedAt
            manuallyAdjustedByUserId
            paymentAmount
            paymentDue
        }
    }
`;

// Hebt einen Tombstone (deletedAt != null) auf — analog zu ClearManuallyAdjusted.
// Server-Resolver prüft bereits auf paid-Guard und Berechtigungen
// (Admin/Superuser/SuperAdmin/Instructor); Frontend reicht nur den Fehler durch.
export const RESTORE_SCHEDULED_PAYMENT = gql`
    mutation RestoreScheduledPayment($id: String!) {
        restoreScheduledPayment(id: $id) {
            id
            deletedAt
            deletedByUserId
            paymentAmount
            paymentDue
        }
    }
`;
